import axios from "axios";

import { checkUserClaims, redirectToSso, refreshAccessToken } from "./authentication";
import { getLocalStorageItem } from "./storage";
import { API_KEY, API_KEY_HEADER, LANGUAGE_HEADER, LANGUAGE } from "./constants";

export const authAxiosInstance = axios.create({
	baseURL: process.env.REACT_APP_API_BASE_URL,
});

export const axiosInstance = axios.create({
	baseURL: process.env.REACT_APP_API_BASE_URL,
});

authAxiosInstance.interceptors.request.use(
	config => {
		config.headers[API_KEY_HEADER] = API_KEY;
		return config;
	},
	error => {
		return Promise.reject(error);
	}
);

authAxiosInstance.interceptors.response.use(
	response => response,
	async (error) => {
		if (error.response?.status >= 500 && window.location.pathname !== "/error") {
			window.location.href = "/error";
		}

		return Promise.reject(error);
	}
);

axiosInstance.interceptors.request.use(
	config => {
		const token = getLocalStorageItem("ACCESS_TOKEN");
		if (token) {
			config.headers.Authorization = `Bearer ${token}`;
			config.headers[API_KEY_HEADER] = API_KEY;
			config.headers[LANGUAGE_HEADER] = LANGUAGE;
		}
		return config;
	},
	error => {
		return Promise.reject(error);
	}
);

axiosInstance.interceptors.response.use(
	response => response,
	async (error) => {
		const originalRequest = error.config;

		if (error.response?.status >= 500 && window.location.pathname !== "/error") {
			window.location.href = "/error";
			throw error;
		}

		if (error.response?.status === 401 && !originalRequest._retry) {
			originalRequest._retry = true;

			redirectToSso();
			// const success = await refreshAccessToken();

			// if (success) {
			// 	return axiosInstance(originalRequest);
			// }
		}else if(error.response?.status === 403){
			const response = await checkUserClaims();
			if (response === "400"){
				redirectToSso();
			}else{
				console.log("403 error");
			}
		}

		return Promise.reject(error);
	}
);


